import api from "./api";
import {resolveUrl} from "./app-config";

function mediaIdentifier(file) {
    return file?.documentId ?? file?.id;
}

export async function requestWorkspaceMediaUrl(
    file,
    workspaceId,
    {format = "original", disposition = "attachment"} = {},
) {
    const identifier = mediaIdentifier(file);
    if (!identifier) throw new Error("media.error.not-found");
    if (!workspaceId) throw new Error("media.error.workspace-required");

    const response = await api.post(
        `/workspace-media/${encodeURIComponent(String(identifier))}/access`,
        {
            format,
            disposition: disposition === "inline" ? "inline" : "attachment",
        },
        {headers: {workspace: workspaceId}},
    );
    const url = resolveUrl(response?.data?.data?.url);
    if (!url) throw new Error("media.error.unavailable");
    return url;
}

export async function downloadWorkspaceMedia(file, workspaceId) {
    const url = await requestWorkspaceMediaUrl(file, workspaceId, {
        format: "original",
        disposition: "attachment",
    });
    const link = document.createElement("a");
    link.href = url;
    link.rel = "noopener noreferrer";
    link.download = file?.name || "";
    document.body.appendChild(link);
    link.click();
    link.remove();
    return url;
}

export async function copyWorkspaceMediaLink(file, workspaceId) {
    const url = await requestWorkspaceMediaUrl(file, workspaceId, {
        format: "original",
        disposition: "attachment",
    });
    await navigator.clipboard.writeText(url);
    return url;
}

export async function getWorkspaceStorageUsage(workspaceId) {
    if (!workspaceId) throw new Error("media.error.workspace-required");
    const response = await api.get("/workspace-media/storage-usage", {
        headers: {workspace: workspaceId},
    });
    return response?.data?.data || null;
}
